<form [formGroup]="formName">
    <div class="form-check">
    <input
      id="checkbox-{{htmlId}}"
      type="checkbox"
      name="{{name}}"
      [formControlName]="name"
      [required]="required"
      value="true"
      class="form-check-input border border-dark"
      [ngClass]="{
        'is-invalid': formName.get(name)?.invalid && (formName.get(name)?.dirty || formName.get(name)?.touched),
        'is-valid': (required ? (formName.get(name)?.valid && (formName.get(name)?.dirty || formName.get(name)?.touched)) : (formName.get(name)?.value && (formName.get(name)?.dirty || formName.get(name)?.touched))),
        'ng-valid': (required ? (formName.get(name)?.valid && (formName.get(name)?.dirty || formName.get(name)?.touched)) : (formName.get(name)?.value && (formName.get(name)?.dirty || formName.get(name)?.touched))),
        'custom-valid': (required ? (formName.get(name)?.valid && formName.get(name)?.value) : (formName.get(name)?.valid && formName.get(name)?.value))
      }"

    />
    <label class="form-check-label ps-3" for="checkbox-{{htmlId}}">
      {{ label }}
    </label>
  </div>
  <ng-container *ngIf="formName.get(name)?.invalid && (formName.get(name)?.dirty || formName.get(name)?.touched)">
    <div class="error-message text-warning ps-2">
      <div *ngIf="formName.get(name)?.errors?.['required']">
        <span>{{ 'General.ErrorRequired' | translate }}</span>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="error">
    <div class="error-message text-warning ps-2">
      {{ errorMessage }}
    </div>
  </ng-container>
</form>
